module.exports = __webpack_public_path__ + "static/fire-savings-rate-0f5b6e8bb01c955075226302fa5ff105.png";